import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconJobboard(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 0 0-2-2ZM3 17V5h18v12H3Zm2-9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8Zm2 1v4h4V9H7Zm9-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm-1 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm1 2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
